import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface ImageCarouselProps {
  images: { src: string; alt: string }[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: 'center',
    containScroll: 'trimSnaps',
    dragFree: true
  });

  const scrollPrev = () => {
    if (emblaApi) {
      try {
        emblaApi.scrollPrev();
      } catch (error) {
        console.warn('Carousel scroll prev error:', error);
      }
    }
  };

  const scrollNext = () => {
    if (emblaApi) {
      try {
        emblaApi.scrollNext();
      } catch (error) {
        console.warn('Carousel scroll next error:', error);
      }
    }
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    console.warn('Image failed to load:', e.currentTarget.src);
    e.currentTarget.style.opacity = '0.5';
  };

  return (
    <div className="relative px-12">
      <div className="overflow-hidden rounded-lg" ref={emblaRef}>
        <div className="flex gap-4">
          {images.map((image, index) => (
            <div key={index} className="flex-[0_0_100%] min-w-0">
              <div className="relative aspect-square max-w-md mx-auto">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover rounded-lg shadow-2xl shadow-brand-purple/20"
                  loading="lazy"
                  onError={handleImageError}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={scrollPrev}
        className="absolute left-0 top-1/2 -translate-y-1/2 bg-brand-purple/50 hover:bg-brand-purple text-white p-2 rounded-full transition-colors z-10"
        aria-label="Previous image"
      >
        <ChevronLeft className="h-6 w-6" />
      </button>

      <button
        onClick={scrollNext}
        className="absolute right-0 top-1/2 -translate-y-1/2 bg-brand-purple/50 hover:bg-brand-purple text-white p-2 rounded-full transition-colors z-10"
        aria-label="Next image"
      >
        <ChevronRight className="h-6 w-6" />
      </button>
    </div>
  );
};

export default ImageCarousel;